const MarkdownLinksOnly = ({ content }) => {
    const convertLinks = () => {
      const linkRegex = /\[([^\]]+)\]\(([^)]+)\)/g;
      return content.replace(linkRegex, '<a href="$2">$1</a>');
    };
  
    return <span dangerouslySetInnerHTML={{ __html: convertLinks() }} />;
  };
  
  export default MarkdownLinksOnly;